if (!customElements.get('event-countdown')) {
  class EventCountdown extends HTMLElement {
    connectedCallback() {
      if (this.countdownTimer) {
        return;
      }

      this.endTime =
        Number(this.dataset.countdownEnd) * 1000;

      if (!Number.isFinite(this.endTime) || this.endTime <= 0) {
        this.hidden = true;
        return;
      }

      this.daysElement =
        this.querySelector('[data-countdown-days]');

      this.hoursElement =
        this.querySelector('[data-countdown-hours]');

      this.minutesElement =
        this.querySelector('[data-countdown-minutes]');

      this.secondsElement =
        this.querySelector('[data-countdown-seconds]');

      this.updateCountdown();

      this.countdownTimer = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }

    disconnectedCallback() {
      this.stopCountdown();
    }

    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    }

    updateCountdown() {
      const difference =
        this.endTime - Date.now();

      if (difference <= 0) {
        this.stopCountdown();
        this.hidden = true;
        return;
      }

      const totalSeconds =
        Math.floor(difference / 1000);

      const days =
        Math.floor(totalSeconds / 86400);

      const hours =
        Math.floor((totalSeconds % 86400) / 3600);

      const minutes =
        Math.floor((totalSeconds % 3600) / 60);

      const seconds =
        totalSeconds % 60;

      if (this.daysElement) {
        this.daysElement.textContent =
          String(days).padStart(2, '0');
      }

      if (this.hoursElement) {
        this.hoursElement.textContent =
          String(hours).padStart(2, '0');
      }

      if (this.minutesElement) {
        this.minutesElement.textContent =
          String(minutes).padStart(2, '0');
      }

      if (this.secondsElement) {
        this.secondsElement.textContent =
          String(seconds).padStart(2, '0');
      }
    }
  }

  customElements.define(
    'event-countdown',
    EventCountdown
  );
}